import React from 'react';

const SubHeading = ({ title }) => (
  <div style={{ marginBottom: '2rem' }}>
    <p className="p__cormorant_1">{title}</p>
  </div>
);

export default SubHeading;
